var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 5.50016V12.0002C13.3334 14.0002 12.1401 14.6668 10.6667 14.6668H5.33341C3.86008 14.6668 2.66675 14.0002 2.66675 12.0002V5.50016C2.66675 3.3335 3.86008 2.8335 5.33341 2.8335C5.33341 3.24683 5.50006 3.62016 5.7734 3.89349C6.04673 4.16683 6.42008 4.3335 6.83341 4.3335H9.16675C9.99341 4.3335 10.6667 3.66016 10.6667 2.8335C12.1401 2.8335 13.3334 3.3335 13.3334 5.50016Z",
    stroke: "#9AB0BC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 2.8335C10.6666 3.66016 9.99325 4.3335 9.16659 4.3335H6.83325C6.41992 4.3335 6.04657 4.16683 5.77323 3.89349C5.4999 3.62016 5.33325 3.24683 5.33325 2.8335C5.33325 2.00683 6.00659 1.3335 6.83325 1.3335H9.16659C9.57992 1.3335 9.95327 1.50017 10.2266 1.7735C10.4999 2.04683 10.6666 2.42016 10.6666 2.8335Z",
    stroke: "#9AB0BC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 8.6665H7.99992",
    stroke: "#9AB0BC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 11.3335H10.6666",
    stroke: "#9AB0BC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b001da8307205750eb580b433a6565e2.svg";
export { ForwardRef as ReactComponent };